<template>
  <div class="rights-feature rights-feature--credit_coin">
    <div class="flex-y-center justify-between text-14 -mt-[5px]">
      <div class="flex gap-[5px] font-bold text-font-1">
        {{ $t('yun-chu-cun-kong-jian') }}
        <a-popover placement="bottom">
          <template #content>
            <span class="text-font-1">
              {{
                $t(
                  'cun-chu-rong-liang-ke-die-jia-sheng-xiao-ru-guo-cun-chu-kong-jian-dao-qi-wei-xu-fei-dui-ying-de-cun-chu-kong-jian-jiang-hui-bei-shou-hui'
                )
              }}
            </span>
          </template>
          <iconpark-icon
            class="text-font-60 cursor-pointer"
            size="16"
            name="icon-circle-info"
          ></iconpark-icon>
        </a-popover>
      </div>
      <div class="flex-y-center">
        <slot name="extra"></slot>
      </div>
    </div>
    <div>
      <a-progress
        :percent="usedStorage"
        :strokeColor="isOverStorage ? '#CA0000' : '#29D8E2'"
        :success="{
          percent: useTeamSpace,
          strokeColor: isOverStorage ? '#CA0000' : '#6962FF',
        }"
        :showInfo="false"
      ></a-progress>
      <div class="text-font-60 text-14 text-right -mt-[5px]">
        {{ $t('yi-shi-yong') }}：
        <span
          class="text-font-1"
          :class="{
            '!text-error': isOverStorage,
          }"
        >
          {{ getFormateFileSize(storageInfo.total_used_storage, false) }}
        </span>
        /
        {{ getFormateFileSize(storageInfo.total_storage, false) }}
        <span v-if="storageInfo.buy_more_storage">
          ({{
            $t(
              'getformatefilesizestorageinfobuymorestorage-false-wei-jia-gou-cun-chu',
              [getFormateFileSize(storageInfo.buy_more_storage, false)]
            )
          }})
        </span>
      </div>
    </div>
    <a-alert v-if="isOverStorage" type="warning" show-icon class="my-[5px]">
      <template #message>
        <span v-if="isPersonal">
          {{
            $t('yun-cun-chu-kong-jian-yi-man-qing-sheng-ji-quan-yi-hou-cao-zuo')
          }}
        </span>
        <span v-else>
          {{
            $t(
              'yun-cun-chu-kong-jian-yi-man-qing-jia-gou-cun-chu-kong-jian-hou-cao-zuo'
            )
          }}
        </span>
      </template>
      <template v-if="isPersonal" #action>
        <span class="alert-action" @click="emits('upgrade')">
          {{ $t('sheng-ji-quan-yi') }}
        </span>
      </template>
    </a-alert>
    <div class="storage-content gap-[20px] !mt-[10px]">
      <FeatureStorageCard
        v-if="!isPersonal"
        :type="TEAM_COLOR.team"
        :data="storageInfo.team_used_storage"
        :total="storageInfo.team_used_total"
        :percent="storageInfo.team_used_total / storageInfo.total_storage"
      >
      </FeatureStorageCard>
      <FeatureStorageCard
        :type="isPersonal ? TEAM_COLOR.person : TEAM_COLOR.teamPerson"
        :data="storageInfo.personal_used_storage"
        :total="storageInfo.personal_used_total"
        :percent="storageInfo.personal_used_total / storageInfo.total_storage"
      >
        <template v-if="!isPersonal" #extra>
          <StorageMemberModal />
        </template>
      </FeatureStorageCard>
    </div>
  </div>
</template>

<script setup lang="ts">
import StorageMemberModal from './storageMemberModal.vue'
import FeatureStorageCard from './featureStorageCard.vue'
import { fetchStorageInfo } from '~/api'
import { USER_LEVEL_KEY } from '~/api/interface'

const emits = defineEmits(['upgrade'])
const { $t } = useNuxtApp()

const currentUser = useUserInfo()

const TEAM_COLOR = {
  person: {
    name: $t('ge-ren-kong-jian'),
    color: '#29D8E2',
  },
  teamPerson: {
    name: $t('cheng-yuan-ge-ren-kong-jian'),
    color: '#29D8E2',
  },
  team: {
    name: $t('tuan-dui-kong-jian'),
    color: '#6962FF',
  },
}

// const isTas

const isPersonal = computed(() =>
  [
    USER_LEVEL_KEY.PERSONAL,
    USER_LEVEL_KEY.PERSONAL_LITE,
    USER_LEVEL_KEY.TASTE,
  ].includes(Number(currentUser.value?.rights_type))
)

const storageInfo: any = ref({})
const STORAGE_MAP: any = {
  // project: {
  //   name: '作品',
  //   color: '#6962FF',
  // },
  task: {
    name: $t('cheng-pian'),
    color: '#29E69C',
  },
  // task_template: {
  //   name: '成片模板',
  //   color: '#FF5656',
  // },
  media: {
    name: $t('zi-yuan'),
    color: '#FFB53D',
  },
}
// 已使用存储空间
const usedStorage = computed(
  () =>
    ((storageInfo.value.total_storage - storageInfo.value.storage) /
      storageInfo.value.total_storage) *
    100
)

// 溢出内容
// const overStorage = computed(
//   () => storageInfo.value.total_storage - storageInfo.value.total_used_storage
// )

// 是否溢出
const isOverStorage = computed(
  () => storageInfo.value.total_storage < storageInfo.value.total_used_storage
)

// 团队已使用的空间
const useTeamSpace = computed(() =>
  storageInfo.value.team_used_total
    ? (storageInfo.value.team_used_total / storageInfo.value?.total_storage) *
      100
    : 0
)

const initData = (data: any) => {
  const result = Object.keys(data)
    ?.map((item) => {
      return {
        value: data[item],
        ...STORAGE_MAP[item],
      }
    })
    .filter((item) => item.name)

  return {
    total: data.total_used_storage,
    result,
  }
}

const fetchData = async () => {
  const res = await fetchStorageInfo()

  if (!res.code && res.data) {
    const personData = initData(res.data.personal_used_storage)
    const teamData = res.data.team_used_storage
      ? initData(res.data.team_used_storage)
      : undefined

    storageInfo.value = {
      ...res.data,
      personal_used_storage: personData.result,
      personal_used_total: personData.total,
      ...(res.data.team_used_storage && {
        team_used_storage: teamData?.result,
        team_used_total: teamData?.total,
      }),
    }
  }
}

onMounted(() => {
  emitter.on(EVENT.UPDATE_USER, () => {
    fetchData()
  })
})

fetchData()
</script>

<style lang="scss" scoped>
.chart-item {
  @apply bg-back-1 p-[30px] w-full h-full flex-y-center justify-between  gap-[30px];
}
</style>
